import React, { Component } from "react";
import { Badge, Button, Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { updateSejoursModelsEventsPrices__action } from "../../../../../../actions/sejours.globals.actions";
import ConfirmDialog from "../../../../../../components/custom-boostrap/ConfirmDialog";
import EditAddPriceModal from "../../../../../../components/pages/sejours/prices/modals/edit-add-modal";
import ContextMenu from "../../../../../../components/shared/context-menu";
import { MODEL_RELATION_TYPE } from "../../../../../../constants/api/sejours";
import { apiRequest } from "../../../../../../functions/api";
import { isEmpty, lengthObject } from "../../../../../../functions/common";
import { pushNotification } from "../../../../../../functions/notifications";
import { getDeepState, setDeepState } from "../../../../../../functions/react.utilities";
import DeleteModal from "./delete-modal";
import EditAddModal from "./edit-add-modal";

class PricesTab extends Component{
    constructor(props) {
        super(props);

        this.setDeepState = setDeepState(this).bind(this);
        this.getDeepState = getDeepState(this).bind(this);
        this.setState = this.setState.bind(this);

        this.state = {
            modals : {
                editAdd : false,
                editConfigs : false,
                delete : false
            },
            selection : [],
            editConfigs : false,
            configsSaving : false,
            configs : this.getConfigs(),
            PIDToEdit : null
        }
        this.editAddMode = EditAddPriceModal.modes.add;
        this.selection = {};

        this.launchCreatePrice = this.launchCreatePrice.bind(this);
        this.launchDeletePricesWithButton = this.launchDeletePricesWithButton.bind(this);


        this.launchEditPriceWithContext = this.launchEditPriceWithContext.bind(this);
        this.launchDeletePriceWithContext = this.launchDeletePriceWithContext.bind(this);
        this.launchConsultPriceWithContext = this.launchConsultPriceWithContext.bind(this);
        this.launchEditPricesConfigurations = this.launchEditPricesConfigurations.bind(this);
        this.launchSavePricesConfigurations = this.launchSavePricesConfigurations.bind(this);
        this.cancelPricesConfigurations = this.cancelPricesConfigurations.bind(this);
        this.savePricesConfigurations = this.savePricesConfigurations.bind(this);

        this.onSelectionChange = this.onSelectionChange.bind(this);
    }

    getModelPricesFromStore(){
        const prices = {};
        Object.keys(this.props.sejours.prices).forEach((PID) => {
            if(this.props.sejours.models[this.props.SID].prices.indexOf(PID) >= 0){
                prices[PID] = this.props.sejours.prices[PID];
            }
        });
        return prices;
    }

    getModelFromStore(){
        return this.props.sejours.models[this.props.SID];
    }

    getPIDSOfSelection(){
        const prices = this.getModelPricesFromStore();
        return Object.keys(prices).filter((PID, i) => (i in this.selection));
    }

    getConfigs(){
        const model = this.getModelFromStore();
        let configs = { ...model.pricesDefaultConfig };

        Object.entries(model.pricesConfig).forEach(([PID, config]) => {
            if(!configs.hasOwnProperty(PID)){
                configs[PID] = {
                    limitEvent : 0,
                    limitRegistration : 0,
                    limitSejour : 0,
                    enableLimitEvent : false,
                    enableLimitRegistration : false,
                    enableLimitSejour : false
                }
            }
            configs[PID] = { ...configs[PID], ...config }
        });

        return configs;
    }

    //Buttons bar functions
    launchCreatePrice(){
        this.editAddMode = EditAddPriceModal.modes.add;
        this.setDeepState(s => { s.modals.editAdd = true });
    }
    
    launchDeletePricesWithButton(){
        if(this.state.selection.length > 0){
            this.setDeepState(s => { 
                s.modals.delete = true;
            });
        }
    }


    //Context menu functions
    launchConsultPriceWithContext(PID){
        alert(`Option indisponible pour le moment ${PID} !`);
    }
    launchDeletePriceWithContext(PID){
        this.setDeepState(s => {
            s.selection = [PID];
            s.modals.delete = true;
        });
    }
    launchEditPriceWithContext(PID){
        this.editAddMode = EditAddPriceModal.modes.edit;
        this.setDeepState(s => {
            s.PIDToEdit = PID;
            s.modals.editAdd = true;
        });
    }

    launchEditPricesConfigurations(){
        let state = this.getDeepState();
        state.configs = this.getConfigs();
        state.editConfigs = true;
        this.setState(state);
    }
    launchSavePricesConfigurations(){
        this.setDeepState(s => {
            s.modals.editConfigs = true;
            s.configSaving = false;
        });
    }
    cancelPricesConfigurations(){
        this.setDeepState(s => {
            s.modals.editConfigs = false;
            s.editConfigs = false;
            s.configSaving = false;
            s.configs = this.getConfigs();
        });
    }
    savePricesConfigurations(applyToEvents){
        if(this.state.editConfigs){
            const newState = this.getDeepState();
            newState.configsSaving = true;
            const pricesConfig = {};
            const pricesDefaultConfig = {};
            Object.entries(this.state.configs).forEach(([PID, configs]) => {
                pricesConfig[PID] = {
                    limitSejour : isEmpty(configs.limitSejour) ? 0 : configs.limitSejour,
                    enableLimitSejour : configs.enableLimitSejour ? true: false
                };

                pricesDefaultConfig[PID] = {
                    limitEvent : isEmpty(configs.limitEvent) ? 0 : configs.limitEvent,
                    enableLimitEvent : configs.enableLimitEvent ? true: false,
                    limitRegistration : isEmpty(configs.limitRegistration) ? 0 : configs.limitRegistration,
                    enableLimitRegistration : configs.enableLimitRegistration ? true : false
                };
            });
            apiRequest({
                url : '/sejours.models.prices.configurations/put',
                data : {
                    SID : this.props.SID,
                    applyToEvents : applyToEvents ? true : false,
                    configurations : {
                        pricesConfig,
                        pricesDefaultConfig
                    }
                }
            })
            .then((res) => {
                const errorNotification = (m) => pushNotification({
                    type : "error",
                    title : "Impossible de mettre à jour les configurations tarifaires",
                    icon : "mdi mdi-close",
                    content : <p>{m}</p>
                });

                const newState = this.getDeepState();
                newState.configsSaving = false;
                newState.editConfigs = false;
                newState.modals.editConfigs = false;

                if(res.data.http_code === 200){
                    if(res.data.status === "success"){
                        this.props.dispatch(updateSejoursModelsEventsPrices__action({
                            models : res.data.data.models ? res.data.data.models : {},
                            events : res.data.data.events ? res.data.data.events : {}
                        }));
                        pushNotification({
                            type : "success",
                            title : "Modifications enregistrées",
                            icon : "mdi mdi-check",
                            content : <p>Les configurations tarifaires ont été enregistrées et appliquées avec succès.</p>
                        });
                    }else{
                        if(res.data.errors){
                            errorNotification(`Erreur du serveur. Veuillez réessayer.`);
                        }else if(res.data.status_code){
                            errorNotification(`Erreur du serveur. (${res.data.status_code})`);
                        }else{
                            errorNotification(`Erreur du serveur. (UNKNOWN)`);
                        }
                    }
                }else{
                    errorNotification(`Erreur du serveur. (${res.data.http_code})`);
                }
                this.setState(newState);
            });

            this.setState(newState);
        }
    }

    onSelectionChange(s){
        if(Object.keys(s).length !== Object.keys(this.selection).length){
            this.forceUpdate();
        }
        this.selection = s;
    }

    getHeader(){
        return(
            <div className="row">
                <div className="col-6 btn-container-inline-left wrap">
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-autoclose-true" size="sm">
                            <i className="mdi mdi-plus"/>Ajouter
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={this.launchCreatePrice}>
                                <Badge className="price-relation-type-badge relation-model" pill>M</Badge>
                                Créer un tarif pour le modèle
                            </Dropdown.Item>
                            <Dropdown.Item disabled title="Option indisponible pour le moment">
                                <Badge className="price-relation-type-badge relation-global" pill>G</Badge>
                                Ajouter un tarif global
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button size="sm" variant="danger" disabled={!(this.state.selection.length > 0)} onClick={this.launchDeletePricesWithButton}><i className="mdi mdi-delete-forever"/>Supprimer</Button>
                </div>
                <div className="col-6 btn-container-inline-right wrap">
                    {this.state.editConfigs ? 
                        <React.Fragment>
                            <Button size="sm" variant="secondary" onClick={this.cancelPricesConfigurations}><i className="mdi mdi-close" />Annuler</Button>
                            <Button size="sm" variant="info" onClick={this.launchSavePricesConfigurations}><i className="mdi mdi-content-save" />Enregistrer</Button>
                        </React.Fragment>
                    :
                        <Button size="sm" variant="info" disabled={!(lengthObject(this.getModelPricesFromStore()) > 0)} onClick={this.launchEditPricesConfigurations}><i className="mdi mdi-pencil" />Éditer les maximums</Button>
                    }
                </div>
            </div>
        )
    }

    getRow(price, i){
        const selectRow = (e) => {
            this.setDeepState(s => {
                const PIDpos = s.selection.indexOf(price.PID);
                if(!(PIDpos >= 0)){
                    s.selection.push(price.PID);
                }else{
                    s.selection.splice(PIDpos, 1);
                }
            });
        }

        const { Menu, show } = ContextMenu.Menu({ id : price.PID });
        const d = {
            amount : `${(price.amount / 100).toFixed(2)} €`,
            description : price.description,
            badge : {
                letter : price.sejourRelationType === MODEL_RELATION_TYPE ? "M" : "G",
                bg : price.sejourRelationType === MODEL_RELATION_TYPE ? "relation-model" : "relation-global",
                title : price.sejourRelationType === MODEL_RELATION_TYPE ? "Tarif propre au modèle" : "Tarif global"
            },
            selected : this.state.selection.indexOf(price.PID) >= 0,
            pricesConfig : this.state.configs.hasOwnProperty(price.PID) ? {...this.state.configs[price.PID]} : {
                enableLimitEvent : false,
                enableLimitRegistration : false,
                enableLimitSejour : false,
                limitEvent : 0,
                limitRegistration : 0,
                limitSejour : 0
            }
        }
        if(this.state.editConfigs){
            d.pricesConfig.limitEventD = (d.pricesConfig.limitEvent === 0 && !d.pricesConfig.enableLimitEvent) ? "" : d.pricesConfig.limitEvent;
            d.pricesConfig.limitRegistrationD = (d.pricesConfig.limitRegistration === 0 && !d.pricesConfig.enableLimitRegistration) ? "" : d.pricesConfig.limitRegistration;
            d.pricesConfig.limitSejourD = (d.pricesConfig.limitSejour === 0 && !d.pricesConfig.enableLimitSejour) ? "" : d.pricesConfig.limitSejour;
            
        }else{
            d.pricesConfig.limitEventD = d.pricesConfig.enableLimitEvent ? d.pricesConfig.limitEvent : '∞';
            d.pricesConfig.limitRegistrationD = d.pricesConfig.enableLimitRegistration ? d.pricesConfig.limitRegistration : '∞';
            d.pricesConfig.limitSejourD = d.pricesConfig.enableLimitSejour ? d.pricesConfig.limitSejour : '∞';
        }

        if(price.amount === 0){
            d.amount = "Gratuit";
        }

        if(price.description.length > 70){
            d.description = price.description.substr(0, 70) + "...";
        }

        const onChange = (prop, e, thisArg) => {
            let state = thisArg.getDeepState();
            switch (prop) {
                case "limitEvent":
                case "limitRegistration":
                case "limitSejour":
                    let isNotEmpty = !isEmpty(e.target.value) || parseInt(e.target.value) === 0;
                    if(!isNaN(e.target.value)){
                        if(isNotEmpty){
                            state.configs[price.PID][prop] = parseInt(e.target.value);
                        }else{
                            state.configs[price.PID][prop] = "";
                        }
                    }else{
                        isNotEmpty = false;
                    }

                    if(prop === "limitEvent"){
                        state.configs[price.PID]["enableLimitEvent"] = isNotEmpty;
                    }else if(prop === "limitRegistration"){
                        state.configs[price.PID]["enableLimitRegistration"] = isNotEmpty;
                    }else if(prop === "limitSejour"){
                        state.configs[price.PID]["enableLimitSejour"] = isNotEmpty;
                    }
                    break;
                    
                case "enableLimitEvent":
                case "enableLimitRegistration":
                case "enableLimitSejour":
                    let empty = true;
                    if(prop === "enableLimitEvent"){
                        empty = isEmpty(state.configs[price.PID]["limitEvent"]) && !(parseInt(state.configs[price.PID]["limitEvent"]) >= 0);
                    }else if(prop === "enableLimitRegistration"){
                        empty = isEmpty(state.configs[price.PID]["limitRegistration"]) && !(parseInt(state.configs[price.PID]["limitRegistration"]) >= 0);
                    }else if(prop === "enableLimitSejour"){
                        empty = isEmpty(state.configs[price.PID]["limitSejour"]) && !(parseInt(state.configs[price.PID]["limitSejour"]) >= 0);
                    }
                    if(!empty){
                        state.configs[price.PID][prop] = e.target.checked ? false : true;
                    }
                    break;
            }
            thisArg.setState(state);
        }

        return(
            <React.Fragment key={i}>
                <div className={`price-row${d.selected ? " selected" : ""}`} onContextMenu={show}>
                    <div className="left-side">
                        <div className="row-selector">
                            <div className="form-check form-check-muted m-0">
                                <label className="form-check-label">
                                    <input  type="checkbox" 
                                            className="form-check-input" 
                                            checked={d.selected} 
                                            onChange={selectRow}
                                    />
                                    <i className="input-helper" />
                                </label>
                            </div>
                        </div>
                        <div className="price-infos">
                            <div className="price-desc-group">
                                <p className="price-label">
                                    <Badge className={`price-relation-type-badge ${d.badge.bg}`} title={d.badge.title} pill>{d.badge.letter}</Badge>
                                    {price.label}
                                </p>
                                <p className="price-desc">
                                    {d.description}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="right-side">
                        <div className="price-amount-options">
                            <p className="price-amount display-5 text-success lh-1">{d.amount}</p>
                            <div className="btn-container-inline-center align-center justify-center m-0">
                                <Button size="md" variant="info" className="btn-rounded btn-icon" onClick={() => this.launchEditPriceWithContext(price.PID)} title="Éditer"><i className="mdi mdi-pencil mr-0"/></Button>
                                <Button disabled size="md" variant="success" className="btn-rounded btn-icon" onClick={() => this.launchConsultPriceWithContext(price.PID)} title={false ? "Voir dans le panneau des tarifs" : "Option indisponible"}><i className="mdi mdi-eye mr-0"/></Button>
                            </div>
                        </div>
                        <div className="max-inputs-group">
                            <div className="max-inputs-group-label">Maximum par</div>
                            <div className="inputs-container">
                                <div className="input-container">
                                    <label className="limit-label" htmlFor={`price-register-${price.PID}`}>Inscription</label>
                                    <input  type="text" 
                                            id={`price-register-${price.PID}`} 
                                            value={d.pricesConfig.limitRegistrationD} 
                                            readOnly={!this.state.editConfigs} 
                                            placeholder="∞"
                                            onChange={(e) => onChange("limitRegistration", e, this)}
                                    />
                                    <label className="no-limit-checkbox">
                                        {this.state.editConfigs ? <>
                                            <input  type="checkbox" 
                                                    tabIndex="-1"
                                                    checked={!d.pricesConfig.enableLimitRegistration} 
                                                    disabled={!this.state.editConfigs} 
                                                    onChange={(e) => onChange("enableLimitRegistration", e, this)}
                                            />
                                            Illimité </>
                                        : <>
                                            { d.pricesConfig.enableLimitRegistration ? "Limité" : "Illimité" }
                                        </> }
                                    </label>
                                </div>
                                <div className="input-container">
                                    <label className="limit-label" htmlFor={`price-event-${price.PID}`}>Événement</label>
                                    <input  type="text" 
                                            id={`price-event-${price.PID}`} 
                                            value={d.pricesConfig.limitEventD} 
                                            readOnly={!this.state.editConfigs} 
                                            placeholder="∞"
                                            onChange={(e) => onChange("limitEvent", e, this)}
                                    />
                                    <label className="no-limit-checkbox">
                                        {this.state.editConfigs ? <>
                                            <input  type="checkbox" 
                                                    tabIndex="-1"
                                                    checked={!d.pricesConfig.enableLimitEvent} 
                                                    disabled={!this.state.editConfigs} 
                                                    onChange={(e) => onChange("enableLimitEvent", e, this)}
                                            />
                                            Illimité </>
                                        : <>
                                            { d.pricesConfig.enableLimitEvent ? "Limité" : "Illimité" }
                                        </> }
                                    </label>
                                </div>
                                <div className="input-container">
                                    <label className="limit-label" htmlFor={`price-model-${price.PID}`}>Séjour</label>
                                    <input  type="text" 
                                            id={`price-model-${price.PID}`} 
                                            value={d.pricesConfig.limitSejourD} 
                                            readOnly={!this.state.editConfigs} 
                                            placeholder="∞"
                                            onChange={(e) => onChange("limitSejour", e, this)}
                                    />
                                    <label className="no-limit-checkbox">
                                        {this.state.editConfigs ? <>
                                            <input  type="checkbox" 
                                                    tabIndex="-1"
                                                    checked={!d.pricesConfig.enableLimitSejour} 
                                                    disabled={!this.state.editConfigs} 
                                                    onChange={(e) => onChange("enableLimitSejour", e, this)}
                                            />
                                            Illimité </>
                                        : <>
                                            { d.pricesConfig.enableLimitSejour ? "Limité" : "Illimité" }
                                        </> }
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Menu>
                        <ContextMenu.Item onClick={() => this.launchConsultPriceWithContext(price.PID)}><span><i className="mdi mdi-eye text-success"/> Consulter</span></ContextMenu.Item>
                        <ContextMenu.Item onClick={() => this.launchEditPriceWithContext(price.PID)}><span><i className="mdi mdi-pencil text-info"/> Modifier</span></ContextMenu.Item>
                        <ContextMenu.Item onClick={() => this.launchDeletePriceWithContext(price.PID)}><span><i className="mdi mdi-close text-danger"/> Supprimer</span></ContextMenu.Item>
                    </Menu>
                </div>

            </React.Fragment>
        )
    }

    getTable(){
        const prices = this.getModelPricesFromStore();
        if(lengthObject(prices) > 0){
            return (
                <div className="prices-rows">
                    {Object.values(prices).map((price, i) => this.getRow(price, i))}
                </div>
            )
        }else{
           return (<p className="col-12 text-muted text-center">Aucun tarif</p>)
        }
    }
    render(){
        return (
            <div className="prices-tab">
                { this.getHeader() }
                { this.getTable() }
                <ConfirmDialog 
                    show={this.state.modals.editConfigs}
                    loading={this.state.configsSaving}
                    loadingMess="Modifications en cours..."
                    loadingInline
                    modalTitle="Comment appliquer les modifications ?"
                    confirm={{ onClick : () => this.savePricesConfigurations(true), disabled : this.state.configsSaving }}
                    decline={{ onClick : () => this.savePricesConfigurations(false), disabled : this.state.configsSaving}}
                    onHide={() => {}}
                >
                    <p className="m-0 text-justify">Voulez-vous que les modifications apportées aux configurations tarifaires, s&apos;applique aux événements déjà existants ?</p>
                </ConfirmDialog>
                <EditAddModal
                    mode={this.editAddMode}
                    show={this.state.modals.editAdd}
                    SID={this.props.SID}
                    PID={this.state.PIDToEdit}
                    parentState={this.state}
                    parentSetState={this.setState}
                    parentSetDeepState={this.setDeepState}
                    parentGetDeepState={this.getDeepState}
                />
                <DeleteModal 
                    show={this.state.modals.delete}
                    PIDS={this.state.selection}
                    parentState={this.state}
                    parentSetState={this.setState}
                    parentSetDeepState={this.setDeepState}
                    parentGetDeepState={this.getDeepState}
                />
            </div>
        )
    }
    
}

const mapStateToProps = (state) => ({ sejours : state.sejours });

export default connect(mapStateToProps, null)(PricesTab);